import ToggleButtons from "../../../../../../../../library/toggle-buttons";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { useSettings } from "../../../../context";
import { FieldWrapper } from "./styled";

const AlignmentConfiguration = () => {
  const { getSelectedItemSettings, updateAlignmentSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "text") {
    return null;
  }

  const handleVerticalAlignChange = (value: any) => {
    updateAlignmentSettings({ vertical: value });
  };

  const handleHorizontalAlignChange = (value: any) => {
    updateAlignmentSettings({ horizontal: value });
  };

  return (
    <>
      <FieldWrapper>
        <ToggleButtons
          selected={currentSettings?.configuration?.alignment?.horizontal}
          className="toggle-buttons"
          variant="secondary"
          options={[
            {
              title: (
                <>
                  {getIcon("align-horizontal-left")}
                  <span>Venstrestilt</span>
                </>
              ),
              value: "left",
            },
            {
              title: (
                <>
                  {getIcon("align-horizontal-center")} <span>Sentrert</span>
                </>
              ),
              value: "center",
            },
            {
              title: (
                <>
                  {getIcon("align-horizontal-right")} <span>Høyrestilt</span>
                </>
              ),
              value: "right",
            },
          ]}
          onSelect={handleHorizontalAlignChange}
        />
      </FieldWrapper>
      <FieldWrapper>
        <ToggleButtons
          selected={currentSettings?.configuration?.alignment?.vertical}
          className="toggle-buttons"
          variant="secondary"
          options={[
            {
              title: (
                <>
                  {getIcon("align-vertical-top")} <span>Topp</span>
                </>
              ),
              value: "flex-start",
            },
            {
              title: (
                <>
                  {getIcon("align-vertical-center")} <span>Sentrert</span>
                </>
              ),
              value: "center",
            },
            {
              title: (
                <>
                  {getIcon("align-vertical-bottom")} <span>Bunn</span>
                </>
              ),
              value: "flex-end",
            },
          ]}
          onSelect={handleVerticalAlignChange}
        />
      </FieldWrapper>
    </>
  );
};

export default AlignmentConfiguration;
